/**
 * Faixas de valor podem se sobrepor ou estar fora de ordem.
 * Entre todas as que contêm o valor numérico, para datas usa-se a mais restritiva
 * (maior min_date_days). Assim, ao reduzir o valor de referência, o prazo mínimo
 * pode baixar corretamente quando deixa de aplicar a faixa mais restrita.
 */

function toFiniteNumberOr(v: any, fallback: number): number {
  if (v === undefined || v === null || v === '') {
    return fallback;
  }
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

/** Dias mínimos vindos do JSON podem ser number ou string. */
export function coerceMinDateDaysValue(raw: any): number | null {
  if (raw === undefined || raw === null || raw === '') {
    return null;
  }
  const n = typeof raw === 'number' ? raw : Number(String(raw).trim());
  if (!Number.isFinite(n)) {
    return null;
  }
  return n;
}

export function pickValueRangeValidationForNumericValue(
  valueRanges: any[],
  numericValue: number,
  evaluateCondition: (condition: any, values: { [fieldId: number]: any }) => boolean,
  values: { [fieldId: number]: any }
): { validation: any } | null {
  if (!Array.isArray(valueRanges)) {
    return null;
  }

  const matching = valueRanges.filter((range: any) => {
    const min = toFiniteNumberOr(range.min, -Infinity);
    const max = toFiniteNumberOr(range.max, Infinity);
    return numericValue >= min && numericValue <= max;
  });

  if (matching.length === 0) {
    return null;
  }

  const resolved = matching.map((range: any) => {
    let validation = range.validation;
    if (Array.isArray(range.conditions)) {
      for (const condition of range.conditions) {
        if (evaluateCondition(condition, values) && condition.override_validation) {
          validation = condition.override_validation;
          break;
        }
      }
    }
    return { range, validation };
  });

  const dateCandidates = resolved
    .map((x) => {
      if (x.validation?.type !== 'min_date_days') {
        return null;
      }
      const days = coerceMinDateDaysValue(x.validation.value);
      if (days === null) {
        return null;
      }
      return {
        validation: {
          ...x.validation,
          value: days,
        },
      };
    })
    .filter(Boolean) as { validation: any }[];

  if (dateCandidates.length > 0) {
    const best = dateCandidates.reduce((a, b) =>
      a.validation.value >= b.validation.value ? a : b
    );
    return { validation: best.validation };
  }

  return { validation: resolved[0].validation };
}
